import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const ProfileSummaryMetric = ({
  classes,
  t,
  metric,
  metricText,
  id,
  onClickHandler
}) => {
  const renderTitle = () => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true
      // {...(onClickHandler ? { classes: { label: classes.buttonLabel } } : { style: { padding: "8px 16px" } })}
      ,
      className: classes.button
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.metricItem,
      id: id,
      align: "center",
      component: "div"
    }, metric), /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      component: "div"
    }, t(metricText)));
  };
  return onClickHandler ? /*#__PURE__*/React.createElement(Button, {
    onClick: onClickHandler,
    className: classes.buttonContainer
  }, renderTitle()) : renderTitle();
};
const styles = theme => ({
  button: {
    borderRadius: 0,
    color: theme.palette.primary.contrastText
  },
  buttonLabel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1
  },
  metricItem: {
    fontWeight: "700 !important"
  },
  spacing: {
    width: "100%",
    textAlign: "center"
  },
  buttonContainer: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  }
});
export default withStyles(styles)(withi18n(ProfileSummaryMetric));
ProfileSummaryMetric.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  metricText: PropTypes.string.isRequired,
  containerStyles: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func
};